import Api from "../helpers/api";

export const vratGeojsonData = async (type, filter) => {
  if (!type || !filter) {
    return false;
  }
  try {
    const response = await Api.get(
      `/api/v1/smartmap/${type}/geojson/${filter}`
    );
    return response.data || false;
  } catch (error) {
    console.error(error);
  }
};

export const vratRozkopavkaGeojsonData = async (type, id) => {
  if (!type || !id) {
    return false;
  }
  try {
    const response = await Api.get(`/api/v1/smartmap/${type}/${id}`);
    return response.data || false;
  } catch (error) {
    console.error(error);
  }
};

export const zmazRozkopavku = async (type, id) => {
  let response = { success: false, errors: [], successes: [] };

  if (!type || !id) {
    return false;
  }

  await Api.delete(`/api/v1/smartmap/${type}/${id}`)
    .then((res) => {
      response.success = true;
    })
    .catch((error) => {
      if (error.response.data) {
        for (const key in error.response.data.errors) {
          error.response.data.errors[key].forEach((err) =>
            response.errors.push(err)
          );
        }
      }
    });

  return response;
};

export const ulozRozkopavku = async (type, data) => {
  let response = { success: false, errors: [], successes: [], data: [] };
  if (!type || data === undefined) {
    response.errors.push("Chybné dáta.");

    return response;
  }

  if (data.id) {
    await Api.put(`/api/v1/smartmap/${type}/${data.id}`, data)
      .then((res) => {
        response.success = true;
        response.successes.push("Úspešne zmenené.");
        response.data = res.data;
      })
      .catch((error) => {
        response.success = false;
        if (error.response.data) {
          for (const key in error.response.data.errors) {
            error.response.data.errors[key].forEach((err) =>
              response.errors.push(err)
            );
          }
        }
      });
  } else {
    await Api.post(`/api/v1/smartmap/${type}`, data)
      .then((res) => {
        response.success = true;
        response.successes.push("Úspešne pridané.");
        response.data = res.data;
      })
      .catch((error) => {
        response.success = false;
        if (error.response.data) {
          for (const key in error.response.data.errors) {
            error.response.data.errors[key].forEach((err) =>
              response.errors.push(err)
            );
          }
        }
      });
  }

  return response;
};
